module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-table"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button devils is-small",
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v(" Load Data ")])]), _vm._v(" "), _c('div', {
    staticClass: "main-table"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return _c('th', {
      key: column,
      staticClass: "table-head",
      attrs: {
        "data-tooltip": "Tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.sortByColumn(column)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("columnHead")(column)) + " \n                        "), (column === _vm.sortedColumn) ? _c('span', [(_vm.order == 'asc') ? _c('i', [_vm._v(" ▲")]) : _c('i', [_vm._v("▼")])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.tableData.length === 0) ? _c('tr', {}, [_c('td', {
    staticClass: "lead text-center",
    attrs: {
      "colspan": _vm.columns.length + 1
    }
  }, [_vm._v("No data found.")])]) : _vm._l((_vm.tableData), function(data) {
    return _c('tr', {
      key: data.id
    }, _vm._l((data), function(value, key) {
      return _c('td', {
        key: key
      }, [_vm._v(_vm._s(value))])
    }), 0)
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-526eb96f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/sort-table.vue
// module id = 620
// module chunks = 30